import React from 'react'

export const PlusIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill="none"
      {...props}
    >
      <path
        fill="#fff"
        d="M9.005 18A9.06 9.06 0 0 0 18 8.995 9.066 9.066 0 0 0 8.995 0 9.058 9.058 0 0 0 0 8.995 9.067 9.067 0 0 0 9.005 18Zm0-1.605a7.365 7.365 0 0 1-7.391-7.4 7.367 7.367 0 0 1 7.38-7.4 7.39 7.39 0 0 1 7.408 7.4 7.368 7.368 0 0 1-7.397 7.4Zm-.02-3.231a.755.755 0 0 0 .77-.855V9.766h2.696a.752.752 0 0 0 .854-.752.753.753 0 0 0-.854-.78H9.755V5.543a.756.756 0 0 0-.77-.854.758.758 0 0 0-.762.854v2.693H5.54a.765.765 0 0 0-.864.78.764.764 0 0 0 .864.751h2.683v2.544a.758.758 0 0 0 .762.854Z"
      />
    </svg>
  )
}

export const BackIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={11}
      height={13}
      fill="none"
      {...props}
    >
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9.34 1 1.002 6.707l8.338 4.735"
      />
    </svg>
  )
}

export const CrossIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M19 5 5 19M5 5l14 14"
      />
    </svg>
  )
}

